// extracted by mini-css-extract-plugin
export default {"container":"SimpleCandleBreakIndicator_container__12LjS"};